<template>
<view class="ticket-card">
    <view class="origin-ticket">原车次</view>
    <view class="place-item">
        {{ticketInfo.pre_from_station_name}}<image class="arrow-right" src="https://img-hxy021.didistatic.com/static/starimg/img/ivL86njzlL1661939706068.png"></image>
        {{ticketInfo.pre_to_station_name}}<text style="font-size: 14px;color: #666666;margin-left:4px">{{ticketInfo.pre_train_code}}</text>
    </view>
    <view class="time-item">{{ticketDate}}</view>
    <view wx:if="{{ticketInfo.reason}}" class="reason-item">改签原因：{{ticketInfo.reason}}</view>
</view>
</template>
<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared/lib/date'

  createComponent({
    props: {
      ticketInfo: Object,
      dateType: {
        type: String,
        value: 'YYYY年MM月dd日 hh:mm'
      }
    },
    computed: {
      ticketDate() {
        return formatDate(this.ticketInfo?.pre_start_time * 1000, this.dateType)
      }
    },
    created() {}
  })
</script>
<style lang='stylus' scoped>
  .origin-ticket
    width 44px
    height 14px
    background #F3F4F5
    border-radius 8px 1px 8px 1px
    font-family PingFangSC-Regular
    font-size 10px
    color #999999
    font-weight 400
    line-height 14px
    text-align center
    position absolute
    left 0px
    top 0px
  .ticket-card
    width calc(100% - 12px)
    background #FFF
    box-sizing border-box
    border-radius 8px
    padding-top 16px
    padding-left 12px
    padding-right 12px
    padding-bottom 12px
    position relative
  .arrow-right
    width 14px
    height 4px
    margin-bottom 4px
    margin-right 4px
    margin-left 4px
  .place-item
    font-family PingFangSC-Medium
    font-size 15px
    color #333
    font-weight 500
  .time-item
    font-family PingFangSC-Light
    font-size 12px
    color #333
    text-align left
    line-height 17px
    font-weight 300
    margin-top 4px
    margin-bottom 2px
  .reason-item
    font-family PingFangSC-Regular
    font-size 12px
    color #999
    text-align left
    line-height 17px
    font-weight 400
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
</style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>